import React, { useContext, useMemo } from "react";
import { Grid } from "@mui/material";
import moment from "moment";
import { useTextDomainContext } from "@/app/providers";
import { TableView1 } from "@/components";
import { useActiveUsersList } from "@/hooks";

/**
 * Active Users List Page
 */
export const ActiveUserList = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const { activeUsersList, loading } = useActiveUsersList("");

  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: gettext("User Name"),
        sortable: false,
        flex: 1,
        minWidth: 150,
        headerAlign: "left",
      },
      {
        field: "email",
        headerName: gettext("Email"),
        flex: 1,
        minWidth: 200,
        headerAlign: "left",
      },
      {
        field: "company",
        headerName: gettext("Company"),
        flex: 1,
        minWidth: 150,
        headerAlign: "left",
      },
      {
        field: "country",
        headerName: gettext("Country"),
        flex: 0.5,
        minWidth: 120,
        headerAlign: "left",
      },
      {
        field: "lastSeen",
        headerName: gettext("Last Seen"),
        flex: 1,
        minWidth: 180,
        headerAlign: "left",
        valueFormatter: (value: unknown) => {
          return value
            ? moment.utc(value as string | number | Date).fromNow()
            : "";
        },
      },
    ],
    [gettext],
  );

  return (
    <Grid container spacing={4} sx={{ width: "100%" }}>
      <Grid size={{ xs: 12 }}>
        <TableView1
          title={gettext("Active Users List")}
          rows={activeUsersList}
          columns={columns}
          loading={loading}
          showGridToolbarQuickFilter={true}
          showGridToolbar
          autoHeight
        />
      </Grid>
    </Grid>
  );
};
